import { Injectable } from '@angular/core';
import { Attachment } from '../_interfaces/attachment';
import { HttpClient } from '@angular/common/http';
import { IDocumentConfiguration } from '../_interfaces/DocumentConfiguration';
import { environment } from 'src/environments/environment';
import { DocumentFile } from '../_interfaces/DocumentFile';
import { Observable } from 'rxjs';
import { IApplicationHeader } from 'src/modules/shared/interfaces/IApplicationHeader';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';
// import { CommonService } from 'src/modules/shared/services/common.service';


@Injectable({
  providedIn: 'root'
})
export class UploadService {
  CustomFilename: any;

  
  private documentAPIUrl: string;



  constructor(private http: HttpClient, private appConfig: AppConfigService) {
    this.documentAPIUrl = this.appConfig.getAppConfig().AppUrl + '/api/Documents';
  }

//-----------------------------------------APIs Actions-------------------------
  uploadFilesToTheTemp(documentConfigration: IDocumentConfiguration, attachments: Attachment[]): Observable<any>  {
        let formData = new FormData();
        let files = new Array<File>();
    
        for (let i = 0; i < attachments.length; i++) {
          files.push( attachments[i].file);
        }
    
        for (let i = 0; i < files.length; i++) {
          formData.append('files', files[i], files[i].name);
        }

        formData.append('documentConfigrationJson', JSON.stringify(documentConfigration));
    
       
        return this.http.post<any>(this.documentAPIUrl + '/UploadFileToTempFolder', formData);  
  }

  MoveFilesToMainFolder(documentsConfigurations: IDocumentConfiguration[], applicationHeader: IApplicationHeader): Observable<any> {
    
    const model = {
      documentsConfigurations : documentsConfigurations,
      applicationHeader: applicationHeader
    }

    return this.http.post<boolean>(this.documentAPIUrl + '/MoveFilesToMainFolder', model);  
  }

  GetFilesPerDocumentConfiguration( documentsConfigurations: IDocumentConfiguration[], applicationHeader: IApplicationHeader): Observable<any> {
    
    const model = {
      documentsConfigurations : documentsConfigurations,
      applicationHeader: applicationHeader
    }

    return this.http.post<IDocumentConfiguration>(this.documentAPIUrl + '/GetFilesPerDocumentConfiguration', model);
  }

  GetFile(documentsConfigurations: IDocumentConfiguration, origin: string, FileName: string, EntityLogicalName: string, requestNumber: string, requestId: string): Observable<any> {
    
    const model = {
      FileName: FileName,
      EntityLogicalName: EntityLogicalName,
      requestNumber: requestNumber,
      requestId: requestId,
      origin: [origin],
      documentsConfigurations: [documentsConfigurations]
    }

    console.log(model);

    return this.http.post<string>(this.documentAPIUrl + '/GetFile', model);  
  } 

  DeleteFile(documentsConfigurations: IDocumentConfiguration, origin: string, FileName: string, EntityLogicalName: string, requestNumber: string, requestId: string, DocumentLocationId: string = ''): Observable<any> {
    
    const model = {
      DocumentLocationId: DocumentLocationId,
      FileName: FileName,
      EntityLogicalName: EntityLogicalName,
      requestNumber: requestNumber,
      requestId: requestId,
      origin: [origin],
      documentsConfigurations: [documentsConfigurations]
    }

    return this.http.post<boolean>(this.documentAPIUrl + '/DeleteFile', model);  
  }

  //----------------------------------------------helpers-----------------------------------------
  downloadFile(fileName,base64)
  {
    var blob: Blob = this.b64toBlob(base64);
    if (window.navigator.msSaveBlob) { // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
        window.navigator.msSaveOrOpenBlob(blob, fileName);
    }
    else {
        var a = window.document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = fileName;
        document.body.appendChild(a);
        a.click();  // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
        document.body.removeChild(a);
    }
  }

  b64toBlob(b64Data, contentType = '', sliceSize = 512) {

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

  var blob = new Blob(byteArrays, {type: contentType});
  return blob;
}

//------------------------------------------------------------------------------------

  getFilesinBas64(attachments: Array<Attachment>): DocumentFile[] {
    let files: DocumentFile[];
    for (let i = 0; i < attachments.length; i++) {
      var fileTemp = {
        FileName:attachments[i].file.name,
        FileData: this.readFileAsDataURL(attachments[i].file)  ,
      }

    }

    return files;
  }

  async readFileAsDataURL(file) {
    
    let result_base64 = await new Promise((resolve) => {
        let fileReader = new FileReader();
        fileReader.onload = (e) => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
    });
  
    console.log(result_base64);
  
    return result_base64;
  }


  // GenerateDocument(ReportModel)
  // {
  //   const model = {
  //     "EntityLogicalName": "string",
  //     "RecordID": "string",
  //     "ReportName": "string",
  //     "ParameterName": "string"
  //   }
  //   return this.http.post<object>(this.documentAPIUrl + '/UploadFileToTempFolder', model);

  // }


 // GetFileNameAndUploadToSharePoint (file){
    // var reader = new FileReaderSync();
    // let dataURL;
    
    // reader.readAsDataURL(file);
  
    // reader.onloadend = function(){
    // dataURL = reader.result;
  
    // dataURL = dataURL.split("base64,")[1];
    // if (dataURL !== undefined) {
    //   return  dataURL;
    // }
    // };
  
    // var ready = false;
    // var result = '';
    
    // var check = function() {
    //     if (ready === true) {
    //          // do what you want with the result variable
    //          return result;
    //     }
    //     setTimeout(check, 1000);
    // }
    
    // check();
    
    // var reader = new FileReader();
    // reader.onloadend = function(evt) {
    //     // file is loaded
    //     result = evt['target']['result'] as string;
    
    //     ready = true;
    // };
    // reader.readAsDataURL(file);
  
 // }
  

  //   GettingByteArray(file) {
    
    //     var reader = new FileReader();
    //     reader.onload = function() {
  
//       var arrayBuffer = this.result as ArrayBuffer,

//         array = new Uint8Array(arrayBuffer),
//         binaryString = String.fromCharCode.apply(null, array);
//         return binaryString;
//     }
//     reader.readAsArrayBuffer(file);
//   }

//   GettingByteArray(file) {
//   let reader = new FileReader();
//   let fileByteArray = [];
//   reader.readAsArrayBuffer(file);
//   reader.onloadend = function (evt) {
//       if (evt.target.readyState == FileReader.DONE) {
//          var arrayBuffer = evt.target.result as ArrayBuffer,
//              array = new Uint8Array(arrayBuffer);
//          for (var i = 0; i < array.length; i++) {
//              fileByteArray.push(array[i]);
//           }
//       }
//   }
//   return fileByteArray;
// }


//  file(file) {
//   // var fileList = document.getElementById("image").files;
//   var fileReader = new FileReader();
//   if (fileReader && file ) {
//      fileReader.readAsArrayBuffer(file);
//      fileReader.onload = function () {
//         var imageData = fileReader.result;
//         return imageData;
//      };
//   }
// }
 



}
